import { toast } from 'react-toastify';

const defaultConfig = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const Toast = (type, value) => {
  switch (type) {
    case 'info':
      toast.info(value, defaultConfig);
      break;
    case 'success':
      toast.success(value, defaultConfig);
      break;
    case 'error':
      toast.error(value, defaultConfig);
      break;
    default:
      break;
  }
};

export default Toast;
